import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchCalendar } from "./learningAPI";

export interface ECPCalendarState {
  calendar: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: ECPCalendarState = {
    calendar: [],
  status: "idle",
};

export const GetCalendar = createAsyncThunk(
  "ECPCalendar/fetchECPCalendar",
  async (data:any) => {
    const response = await fetchCalendar(data);
    return response;
  }
);

export const CalendarSlice = createSlice({
  name: "ECPCalendar",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCalendar.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCalendar.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetCalendar.fulfilled, (state, action) => {
        state.status = "idle";
        state.calendar = action.payload.calender;
      });
  },
});

export const {} = CalendarSlice.actions;

export const selectCalendar = (state: RootState) => {
  return state.Calendar.calendar;
};

export default CalendarSlice.reducer;
